<template>
  <div :style="responsive ? 'width: 100%;' : ''">
    <svg
      ref="histogram"
      :width="responsive ? '100%' : w"
      :height="h"
      :viewBox="responsive ? `0 0 ${w} ${h}` : null"
      :preserveAspectRatio="responsive ? 'none' : null"
    >
      <g v-if="svgData.length > 0">
        <rect
          v-for="(d, i) in svgData.filter(d => d.width > 0)"
          :key="'hb-' + i"
          :x="d.x"
          :y="d.y"
          :width="d.width"
          :height="d.height"
          :fill="d.fill"
        />
      </g>
    </svg>
  </div>
</template>

<script>
import { max } from 'd3-array';
import { scaleLinear } from 'd3-scale';

export default {
  props: {
    data: {
      type: Array,
      required: true,
    },
    width: {
      type: Number,
      default: 100,
    },
    height: {
      type: Number,
      default: 25,
    },
    // Stretch to the container width via a viewBox. Off by default so the
    // fixed-size sparklines in the Variables tab are unaffected.
    responsive: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isLoading: true,
      margin: {
        top: 2,
        right: 2,
        bottom: 2,
        left: 2,
      },
      svgData: [],
    };
  },
  computed: {
    w() {
      const { left, right } = this.margin;
      const { width } = this;
      return width - left - right;
    },
    h() {
      const { top, bottom } = this.margin;
      const { height } = this;
      return height - top - bottom;
    },
  },
  watch: {
    //watch for changes in data
    data: {
      handler: function() {
        this.updateSvgData();
      },

      deep: true,
    },
  },
  mounted() {
    if (this.data != null) this.updateSvgData();
  },
  methods: {
    updateSvgData() {
      let svgData = [];
      let x0 = this.data[0].x0;
      let x1 = this.data[this.data.length - 1].x1;
      let maxl = max(this.data, d => d.length);

      // special case for constant data / zero width bins
      if (x0 == x1) {
        x1 = x1 + 1;
      }

      const xScale = scaleLinear()
        .domain([x0, x1])
        .range([0, this.w]);
      const yScale = scaleLinear()
        .range([this.h, 0])
        .domain([0, maxl]);

      this.data.forEach((d, i) => {
        let x = xScale(d.x0);
        let y = yScale(d.length);
        let w = xScale(d.x1) - x - 1;
        let h = this.height - y;

        // special case for constant data / zero width bins
        if (w <= 0) {
          w = this.w - 1;
        }

        svgData.push({
          id: i,
          x: x,
          y: y,
          width: w,
          height: h,
          fill: '#3F51B5',
        });
      });
      this.svgData = svgData;
    },
  },
};
</script>

<style lang="scss" scoped></style>
